import type { BlogHeading } from '@/lib/data/blog';

/** Jump-link nav for long guide posts. Hidden for short posts with few sections. */
export default function TableOfContents({ headings }: { headings: BlogHeading[] }) {
    if (headings.length < 3) return null;

    return (
        <nav
            aria-label="Table of contents"
            className="not-prose mb-8 rounded-lg border border-gray-200 bg-gray-50 p-5"
        >
            <p className="text-sm font-semibold text-gray-900 mb-3">Jump to a section</p>
            <ol className="space-y-2 text-sm">
                {headings.map((heading, index) => (
                    <li key={heading.id}>
                        <a href={`#${heading.id}`} className="text-blue-600 hover:text-blue-700">
                            {index + 1}. {heading.text}
                        </a>
                    </li>
                ))}
            </ol>
        </nav>
    );
}
